import React, { Component } from 'react'
import { MDBContainer, MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon,MDBRow, MDBCol,MDBDataTable   } from 'mdbreact';
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip ,PageHeader  } from 'antd';
import Axios from 'axios'

import adminfaculty from '../adminfaculty/adminfaculty';
import Modaladdexpertbn from './Modaladdexpertbn';
//import Modalarticletyps from './Modalarticletypes';
import { URL,api } from '../../api';
import Modaladdadmintype from './Modaladdadmintype';





export default class superadminmanage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            article:[]
        };
        // this.handleChange = this.handleChange.bind(this);
        // this.handleChange2 = this.handleChange2.bind(this);
         this.updateat = this.updateat.bind(this);
         this.list = this.list.bind(this);
      }


    componentDidMount() {

        // const token = JSON.parse(localStorage.getItem('nameuser'));
        if (localStorage.getItem('nameuser') == null) {
            window.location.href = '/'
        } else {
    
        }

        setTimeout(() => {
           
          api.get('registercon/selectadmintype')
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ article: res.data})
           }) 
         }, 0);

      }

      list() {

        setTimeout(() => {
          api.get('registercon/selectadmintype')
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ article: res.data})
           }) 
         }, 0);

      }


      updateat(){
        setTimeout(() => {
           
          api.get('registercon/selectregisterall')
         .then(res => {
           console.log(res);
         //  this.setState({ bankname: res.data, loading: false })
           this.setState({ article: res.data})
         }) 
       }, 0);
      }



    render() {

      
      const datast = {
        columns: [
          {
            label: '#',
            field: 'list',
            sort: 'list',
            width: 150
          },
          {
            label: 'ชื่อผู้ดูแลระบบ',
            field: 'name_admin',
            sort: 'name_admin',
            width: 150
          },
          {
            label: 'Username',
            field: 'username_admin',
            sort: 'username_admin',
            width: 150
          },
          {
            label: 'Password',
            field: 'password_admin',
            sort: 'password_admin',
            width: 150
          },
          {
            label: 'สถานะ',
            field: 'status_admin',
            sort: 'status_admin',
            width: 150
          },
          {
            label: 'ประเภทที่ดูแล',
            field: 'presentype_name',
            sort: 'presentype_name',
            width: 150
          },
      
        ],
  
  
        rows: [...this.state.article.map((data, i) => (
          {
             list: <>{i+1}</>,
             name_admin: <>{data.name_admin}</>,
             username_admin: <>{data.username_admin}</>,
             password_admin: <>{data.password_admin}</>,
             status_admin: <>{data.status_admin}</>,
             presentype_name: <>{data.presentype_name}</>,
            
          }
         ))]
    
        };
            const persons = <MDBDataTable
          // searching ={true}
            searchLabel="ค้นหา ชื่อ"
            striped
            bordered
            small 
            entries={50}
          // entriesOptions={["10", "20"]}
            order={["age", "desc"]}
            data={datast}
            entriesLabel="จำนวนที่แสดง "
            infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
            paginationLabel={["ย้อนกลับ", "ถัดไป"]}
            responsive 
            sortRows={['random']}
             theadColor="grey lighten-1"
          //  theadColor={"#ff4444"}
            />



        return (
            <MDBContainer fluid>
            <div>
        
            <p className="text-right">สวัสดีคุณ : {localStorage.getItem('nameuser')} (ผู้ดูแลระบบกลาง)</p>
            {/* <p className="text-right">การประชุมวิชาการระดับชาติ สำหรับนักศึกษา ครั้งที่ 3 สถาบันวิจัยและพัฒนา มหาวิทยาลัยราชภัฏกำแพงเพชร</p>  */}
         
               <MDBAlert color="secondary" >
                   {/* <h2> <MDBIcon far icon="file-alt" /> ข้อมูลผู้ทรงคุณวุฒิ</h2> */}
               
                 
                    <MDBRow >
                    <MDBCol md="8">
                        <PageHeader
                        className="site-page-header"
                      //  onBack={() => null}
                        title="ข้อมูลผู้ดูแลระบบ"
                        subTitle="จัดการข้อมูลผู้ดูแลระบบ"
                        avatar={{ src: 'https://cdn-icons-png.flaticon.com/512/5399/5399692.png' }}
                    />
                    </MDBCol>
                    <MDBCol md="4">
                        <Modaladdadmintype iduser={localStorage.getItem('iduser')} list={this.list} />
                    </MDBCol>
                    </MDBRow>
   </MDBAlert>
 
                {/* <MDBTable responsive>
                    <MDBTableHead color='light'>
                        <tr>
                        <th>ลำดับ</th>
                        <th>ชื่อผู้ดูแลระบบ</th>
                        <th>Username</th>
                        <th>Password</th>
                        <th>สถานพ</th>
                        <th>ประเภทที่ดูแล</th>
                        </tr>
                    </MDBTableHead>

                    <MDBTableBody>
                    {this.state.article.map((article,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        <td>{article.name_admin}</td>
                        <td>{article.username_admin}</td>
                        <td>{article.password_admin}</td>
                        <td>{article.status_admin}</td>
                        <td>{article.presentype_name}</td>
                        </tr>
                      )}
                    </MDBTableBody>
                    </MDBTable> */}
                    {persons}

            </div>
            </MDBContainer>
        )
    }
}
